
((BlogLoader, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.desktopLinkTarget = $('.blog-nav-wrapper a');
    $dom.mobileLinkTarget = $('.mobile-menu a');
    $dom.paginationLink = $('.pagination-position a');  
  }
  
  const bindUIActions = () => {
  	let linkTarget;
  	const width = $(window).width();
  	
  	if(width > 992){
  		  linkTarget = $dom.desktopLinkTarget; 
  	}else{
  		  linkTarget = $dom.mobileLinkTarget; 
  	}

    $(document).on('click', '.blog-pagination a', event => {
        event.preventDefault();
      
      	const linkUrl = $(event.currentTarget).attr('href');
      	const fetchUrl = linkUrl + '&view=ajax';
    		$.get(fetchUrl)
    		.done(function (result) {
          $(".blog-main-content").html(result);
          const scrollToTop = $(".blog-hero").height();
          $("html, body").animate({ scrollTop: scrollToTop }, 500);
          return false;
    		});
      })
  };

  BlogLoader.init = () => {
    cacheDom();
    bindUIActions();
  }

})(window.BlogLoader = window.BlogLoader || {}, jQuery);